/* Foamera — MOBILE-ONLY steps-first PDP

   Desktop is deliberately left EXACTLY as the theme built it:
     right column = title / trust / price / prose (bullets + tabs) / payment
     configurator = full-width block below.

   Mobile only (≤1023px): everything stacks, and the prose + payment row sat
   between the price and the steps — pushing the configurator ~600px down.
   So on mobile we move ONLY the prose block and the payment row to the end of
   the step container, under Review & Confirm. The steps then land right under
   the price. The step container itself is never moved.

   Reversible: original positions are captured before the first move and restored
   if the viewport crosses back to desktop.
   Step logic, step order and all imagery are untouched.

   ── 2026-09-10 düzeltmesi ────────────────────────────────────────────────
   Önceki sürüm oturum başına 100'den fazla şu hatayı fırlatıyordu:
     NotFoundError: Failed to execute 'insertBefore' on 'Node':
     The node before which the new node is to be inserted is not a child of this node.

   İki sebebi vardı:
     1) `review` querySelector ile HERHANGİ bir derinlikte bulunuyor, ama
        insertBefore `grid` üzerinde çağrılıyordu. review grid'in torunu ise
        `review.nextSibling` grid'in çocuğu değildir → istisna.
     2) `put()` anlık görüntüdeki `next` düğümünü kullanıyor; o düğüm aradan
        DOM değişince artık aynı ebeveynin çocuğu olmayabiliyor → istisna.

   Çözüm: her yerleştirme referansın gerçek ebeveynine göre yapılıyor ve
   referans geçersizse appendChild'a düşülüyor. Ayrıca yerleştirme bir kez
   başarılı olduğunda 250ms'lik yoklama durduruluyor — CPU boşuna yanmıyor. */
(function () {
  'use strict';

  var MQ = window.matchMedia('(max-width: 1023px)');
  var saved = null;

  function snap(el) {
    return el && el.parentNode ? { el: el, parent: el.parentNode, next: el.nextSibling } : null;
  }

  /* Tek güvenli yerleştirme yolu. ref yoksa ya da ref parent'ın çocuğu
     değilse sona ekler; asla istisna fırlatmaz. */
  function place(parent, el, ref) {
    if (!parent || !el) return false;
    try {
      if (ref && ref.parentNode === parent) parent.insertBefore(el, ref);
      else parent.appendChild(el);
      return true;
    } catch (e) {
      return false;
    }
  }

  function put(s) {
    if (!s || !s.parent) return;
    /* s.next aradan taşınmış olabilir — place() bunu kendisi ele alıyor */
    place(s.parent, s.el, s.next);
  }

  function apply() {
    var grid = document.querySelector('.pcfg-below-grid');
    if (!grid) return false;

    var review = grid.querySelector('[data-pcfg-review-section]');
    var anchor = review || grid.lastElementChild;
    if (!anchor) return false;

    var slot = document.querySelector('[data-pcfg-info-slot]');
    var pay = document.querySelector('.pcfg__payment-row');
    if (!slot && !pay) return false;

    if (!saved) saved = {};
    /* capture home position BEFORE the first move so desktop can be restored */
    if (slot && !saved.slot && !slot.classList.contains('fmr-info-below')) saved.slot = snap(slot);
    if (pay && !saved.pay && !pay.classList.contains('fmr-pay-below')) saved.pay = snap(pay);

    /* KRİTİK: anchor grid'in torunu olabilir. Yerleştirme her zaman
       anchor'ın GERÇEK ebeveynine göre yapılır, grid'e göre değil. */
    var host = anchor.parentNode || grid;
    var ok = false;

    if (slot) {
      slot.classList.add('fmr-info-below');
      ok = place(host, slot, anchor.nextSibling) || ok;
      anchor = slot;
      host = anchor.parentNode || host;
    }
    if (pay) {
      pay.classList.add('fmr-pay-below');
      ok = place(host, pay, anchor.nextSibling) || ok;
    }
    return ok;
  }

  function undo() {
    if (!saved) return;
    if (saved.slot) { saved.slot.el.classList.remove('fmr-info-below'); put(saved.slot); }
    if (saved.pay) { saved.pay.el.classList.remove('fmr-pay-below'); put(saved.pay); }
  }

  function sync() {
    if (MQ.matches) return apply();
    undo();
    return true;
  }

  function boot() {
    if (!document.getElementById('pcfg-root')) return;
    sync();
    /* the theme builds .pcfg-below-grid and cfg-core.js fills the info slot async.
       Yerleştirme tuttuğu anda yoklamayı bırak — eskiden 24 tur boyunca
       her 250ms'de bir DOM'u dövüyordu. */
    var t = 0;
    var iv = setInterval(function () {
      var done = sync();
      if (done || ++t > 24) clearInterval(iv);
    }, 250);
    if (MQ.addEventListener) MQ.addEventListener('change', sync);
    else if (MQ.addListener) MQ.addListener(sync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* ── Journal karusel gezinmesi — 13.09.2026 ──────────────────────────────
   Blok mobilde 1219px yer kaplıyordu; kartlar yatay kaydırmaya alındı
   (CSS: foamera-ux.css 24. bölüm). Kaydırılabilir olduğunun görünür tek
   işareti kenardan taşan sonraki kart; Furkan'ın gönderdiği referansta
   ayrıca yuvarlak bir ileri oku var. Onu burada enjekte ediyoruz.

   Düğmeler .pjournal__wrap içine konur, dikey olarak ızgaranın ortasına
   hizalanır ve sınırlarda gizlenir. Izgara kaydırılamıyorsa (masaüstünde
   üç kart yan yana sığıyor) ikisi de gizli kalır — ekstra kural gerekmez. */
(function () {
  'use strict';

  var ICON = {
    next: 'M9 5l7 7-7 7',
    prev: 'M15 5l-7 7 7 7'
  };

  function button(dir, grid) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'fmr-jnav fmr-jnav--' + dir;
    b.setAttribute('aria-label', dir === 'next' ? 'Next articles' : 'Previous articles');
    b.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="' + ICON[dir] + '" fill="none" stroke="currentColor" stroke-width="1.9" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg>';
    b.addEventListener('click', function () {
      var card = grid.querySelector('.pjournal__card');
      if (!card) return;
      var gap = parseFloat(getComputedStyle(grid).columnGap) || 12;
      var step = card.getBoundingClientRect().width + gap;
      /* scrollBy yerine indeksten hesap: kullanıcı animasyon sürerken ikinci
         kez tıklarsa scrollBy bir öncekini iptal edip yerinde sayıyordu
         (ölçüldü: 700ms arayla iki tık → 290'da kaldı). Mevcut konumdan
         en yakın kart indeksini bulup hedefi sınırlara kırpıyoruz. */
      var max = grid.scrollWidth - grid.clientWidth;
      var i = Math.round(grid.scrollLeft / step);
      var target = Math.max(0, Math.min(max, (i + (dir === 'next' ? 1 : -1)) * step));
      grid.scrollTo({ left: target, behavior: 'smooth' });
    });
    return b;
  }

  function setup(grid) {
    if (grid.getAttribute('data-fmr-jnav')) return;
    grid.setAttribute('data-fmr-jnav', '1');

    var host = grid.parentElement;
    if (!host) return;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';

    var prev = button('prev', grid);
    var next = button('next', grid);
    host.appendChild(prev);
    host.appendChild(next);

    function sync() {
      /* dikey konum: ızgaranın ortası (başlık yüksekliği sayfadan sayfaya değişir) */
      var mid = grid.offsetTop + grid.clientHeight / 2;
      prev.style.top = mid + 'px';
      next.style.top = mid + 'px';

      var max = grid.scrollWidth - grid.clientWidth;
      var x = grid.scrollLeft;
      prev.hidden = max <= 2 || x <= 2;
      next.hidden = max <= 2 || x >= max - 2;
    }

    grid.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    if (window.ResizeObserver) { try { new ResizeObserver(sync).observe(grid); } catch (e) {} }
    sync();
    /* görseller yüklendikçe yükseklik değişir */
    window.addEventListener('load', sync);
  }

  function boot() {
    var grids = document.querySelectorAll('.pjournal__grid');
    for (var i = 0; i < grids.length; i++) setup(grids[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
